import * as types from './types'

export default {
  [types.STATE_BREADCRUMB]: [],
}
